<template>
	<div class="reports">
		<div class="text-center" v-if="searching">
			{{ msg }}
		</div>
		<div v-else>
			<div class="row bg-light mx-0 border py-2">
				<div class="col-6">
					<div class="row g-3 align-items-center">
						<div class="col-auto">
							<label for="selectSubscriptions" class="col-form-label">Periodo</label>
						</div>
						<div class="col-auto">
							<select v-model="subscriptionId" class="form-select form-select-sm" @change="changeSubscriptionId" id="selectSubscriptions">
								<option v-for="(item, index) in subscriptions" :key="index" :value="item.id">{{item.id}}</option>
							</select>
						</div>
					</div>
				</div>
				<div class="col-6 text-end">
					<export-excel
						class   = "btn btn-success btn-sm me-1"
						:data   = "jsonDataExcel"
						worksheet = "Lista Suscriptores"
						:name    = "nameFile + '.xls'">
							Excel
						<svg class="bi" width="16" height="16"><use xlink:href="#file-earmark-excel"/></svg>
					</export-excel>
					<button class="btn btn-danger btn-sm" @click="exportToPDF">PDF <svg class="bi" width="16" height="16"><use xlink:href="#file-earmark-pdf"/></svg></button>
				</div>
			</div>

			<div class="row mt-2">
				<div v-if="churchs.length > 0" class="col-lg-4">
					<div class="card mb-2 rounded-0">
						<div class="card-body">
							<div class="list-group-light p-0">
								<div class="list-group-item d-flex justify-content-between align-items-center mb-1">
									<div>
										<div class="fw-bold align-middle text-secondary">
											<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#building"/></svg>
											{{ churchs[orderIndex].type_church.name }} {{ churchs[orderIndex].name }}
										</div>
										<div class="ms-4 text-secondary">Distrito: {{ churchs[orderIndex].district.name }} ({{ churchs[orderIndex].entity.synthetic }})</div>
										<div class="ms-4 text-secondary">{{ churchs[orderIndex].entity.name }}</div>
										<div class="ms-4">
											<span class="text-muted" v-if="churchs[orderIndex].client_id != undefined && churchs[orderIndex].client_id != null">
												CPIL: 
												<span v-if="churchs[orderIndex].client != null && churchs[orderIndex].client != undefined">{{ churchs[orderIndex].client.name }} {{ churchs[orderIndex].client.surname }}</span>
												<span v-else class="text-danger">No está definido</span>
											</span>
											<span class="text-danger" v-else>
												Esta Iglesia no tiene un CPIL asignado
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-2 rounded-0">
						<div class="card-body">
							<h6 @click="clientSendtoIndex = -1" class="pointer">Suscriptores</h6>
							<div v-for="(item, index) in clientsSendto" :key="index" class="border-bottom">
								<div class="pointer my-1" @click="showClientSendtoProductsModal(index)" :class="(clientSendtoIndex == index) ? 'fw-semibold' : 'text-black-50'">
									{{item.sendto}}
									<span class="float-end">{{item.phone}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-8">
					<div v-if="products.length > 0" class="card mb-2 rounded-0">
						<div class="card-body">
							<h6>Productos</h6>
							<div class="row">
								<div class="col-8 text-center">Articulo</div>
								<div class="text-center col-4">Total</div>
							</div>
							<div v-for="(item, index) in products" :key="index" class="row fw-semibold" @click="productIndex = index; clientSendtoIndex = -1">
								<div class="col-8">
									{{item.product}} | <small><i>cod. {{item.product_id}}</i></small>
								</div>
								<div class="text-end col-4">
									<div class="progress rounded-0" style="background-color: transparent" >
										<div class="progress-bar" role="progressbar" aria-label="Example with label" :style="'width:' + percentage(item.quantity) + '%;'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
											{{ item.quantity | formatNumber }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card mb-2 rounded-0" v-show="false">
				<div class="card-body" >
					<div ref="documentPdf" v-if="churchIndex > -1">
						<div class="mb-3 text-center">
							<div class="fw-semibold ">Suscripciones {{subscriptionId}} - {{ churchs[churchIndex].type_church.name }} {{ churchs[churchIndex].name }}</div>
							<div class="" style="margin: -5px; font-size:12px"><small>Distrito {{ churchs[churchIndex].district.name }} ({{churchs[churchIndex].entity.name}})</small></div>
							<div style="margin: -5px; font-size:12px"><i>CPIL: {{ churchs[orderIndex].client.name }} {{ churchs[orderIndex].client.surname }}</i></div>
						</div>
						<div v-for="(item, index) in clientsSendto" :key="index" class="mb-3">
							<div class="border-bottom border-dark fw-semibold">
								{{item.sendto}}
							</div>
							<div class="mx-4">
								<table class="table table-sm">
									<tbody>
										<tr v-for="(ite, inde) in item.products" :key="inde">
											<td>{{ ite.product }}</td>
											<td class="text-end">{{ ite.quantity | formatNumber }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#clientSendtoProductsModal" ref="clientSendtoProductsModal" v-show="false">
			Abrir Client Sendto Modal
		</button>
		<div class="modal fade" id="clientSendtoProductsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLabel" v-if="clientSendtoIndex > -1">{{ clientsSendto[clientSendtoIndex].sendto }}</h6>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<table class="table table-sm table-hover">
							<thead>
								<tr>
									<th>Producto</th>
									<th class="text-end">Cantidad</th>
								</tr>
							</thead>
							<tbody v-if="clientSendtoIndex > -1">
								<tr v-for="(item, index) in clientsSendto[clientSendtoIndex].products" :key="index">
									<td>{{ item.product }}</td>
									<td class="text-end">{{ item.quantity | formatNumber }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import html2pdf from 'html2pdf.js'

	export default {
		name: 'Reports',
		mixins: [mixin, axiosSystem],
		data() {
			return {
				orders: [],
				subscriptions: [],
				subscriptionId: 0,
				orderIndex: -1,
				maxQuantity: 0,
				churchIndex: -1,
				clientSendtoIndex: -1,
				nameFile: 'file',
				productIndex: -1,
				msg: '',
				searching: false
			}
		},
		computed: {
			churchs() {
				let list = []
				this.orders.forEach(e => {
					let index = list.map(el => parseInt(el.id)).indexOf(parseInt(e.church_id))
					if(index == -1) {
						let object = []
						for (const property in e.church) {
							object[property] = e.church[property]
						}
						list.push(object)
					} 
				})
				return list
			},
			clientsSendto() {
				let list = []
				this.orders.forEach(e => {
					let index = list.map(el => parseInt(el.id)).indexOf(parseInt(e.client_sendto_id))
					if(index == -1) {
						let object = []
						for (const property in e.client_sendto) {
							object[property] = e.client_sendto[property]
						}
						list.push(object)
					} 
				})
				list.forEach((e, i) => {
					e.products = []
					this.orders.forEach(el => {
						if(e.id == el.client_sendto_id) {
							el.order_products.forEach(ele => {
								let index = e.products.map(elem => parseInt(elem.product_id)).indexOf(parseInt(ele.product_id))
								if(index > -1) {
									let sum = parseInt(e.products[index].quantity) + parseInt(ele.quantity)
									e.products[index].quantity = sum
								} else {
									let object = []
									for (const property in ele) {
										object[property] = ele[property]
									}
									e.products.push(object)
								}
							})
						}
					})
				})
				list.sort(function (a, b) {
					if (a.sendto > b.sendto) {
						return 1;
					}
					if (a.sendto < b.sendto) {
						return -1;
					}
					return 0;
				})
				return list
			},
			products() {
				let list = []
				this.orders.forEach((e, i) => {
					if(e.church_id == this.churchs[this.churchIndex].id) {
						e.order_products.forEach(el => {
							let index = list.map(ele => parseInt(ele.product_id)).indexOf(parseInt(el.product_id))
							if(index > -1) {
								let sum = parseInt(list[index].quantity) + parseInt(el.quantity)
								list[index].quantity = sum
							} else {
								let object = []
								for (const property in el) {
									object[property] = el[property]
								}
								list.push(object)
							}
						})
					}
				})
				this.maxQuantity = 0
				list.forEach(e => {
					this.maxQuantity = (e.quantity > this.maxQuantity) ? e.quantity : this.maxQuantity
				})
				list.sort(function (a, b) {
					if (a.product > b.product) {
						return 1;
					}
					if (a.product < b.product) {
						return -1;
					}
					return 0;
				})

				return list
			},
			jsonDataExcel() {
				let json = []
				this.clientsSendto.forEach((e, i) => {
					let row = {
						'Suscriptor' : e.sendto
					}
					this.products.forEach(el => {
						row[el.synthetic] = this.quantityClientSendto(el.product_id, i)
					})
					json.push(row)
				});
				let row = {
						'Suscriptor' : 'TOTAL'
					}
				this.products.forEach(el => {
					row[el.synthetic] = parseInt(el.quantity)
				})
				json.push(row)
				return json
			}
		},
		methods: {
			changeSubscriptionId() {
				setTimeout(() => {this.getAllSubscriptions(this.subscriptionId)}, 100)
			},
			exportToPDF() {
				html2pdf(this.$refs.documentPdf,{
					margin: [0.3, 0.5],
					filename: this.nameFile + '.pdf',
					image: { type: 'webp', quality: 1 },
					html2canvas: { dpi: 192, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
				})
			},
			initModuleLocal() {
				if(this.getClientSystem.extras.cpil == true) {
					this.getSubscriptions()
				} else {
					this.$router.push('/')
				}
			},
			getSubscriptions() {
				this.searching = true
				this.setHeadersAuthorization(localStorage.getItem('token'))
				let url = this.getApiBackend + 'subscriptions'
				this.msg = 'Verificando periodos . . .'
				document.title = this.msg
				console.log(url)
				this.axiosSystem('GET', url, 'getSubscriptionsResult', null)
			},
			getSubscriptionsResult(response) {
				console.log(response)
				if(response.data.success == true) {
					this.searching = false
					this.subscriptions = response.data.data
					if(this.subscriptions.length > 0) {
						this.subscriptionId = this.subscriptions[this.subscriptions.length - 1].id
						this.getAllSubscriptions(this.subscriptionId)
					}
				} else {
					this.msg = 'No se encontró ningún periodo de suscripciones para consultar'
					document.title = this.msg
				}
			},
			getAllSubscriptions(subscriptionId) {
				this.searching = true
				this.orders = []
				this.orderIndex = -1
				this.maxQuantity = 0
				this.churchIndex = -1
				this.clientSendtoIndex = -1
				this.productIndex = -1
				let url = this.getApiBackend + 'statistics/' + subscriptionId + '/church'
				this.msg = 'Buscando todas las suscripciones para el año ' + subscriptionId + ' . . .'
				document.title = this.msg
				console.log(url)
				this.axiosSystem('POST', url, 'getAllSubscriptionsResult', null)
			},
			getAllSubscriptionsResult(response) {
				if(response.data.success == true) {
					this.searching = false
					this.msg = 'Reporte suscripciones ' + this.subscriptionId
					document.title = this.msg
					this.orders = response.data.data
					if(this.orders.length > 0) {
						this.orderIndex = 0
						this.churchIndex = 0
						this.nameFile = 'iglesia' + this.churchs[this.churchIndex].id + '-' + this.subscriptionId
					}
				} else {
					this.msg = 'No se logró encontrar suscripciones para el periodo ' + this.subscriptionId
					document.title = this.msg
				}
			},
			initials(str) {
				let initial = ''
				let strArr = str.split(' ')
				strArr.forEach(e => {
					initial+= e.substring(0, 1).toUpperCase()
				})
				return initial
			},
			quantityClientSendto(productId, clientSendtoIndex = -1) {
				let sum = 0
				clientSendtoIndex = (clientSendtoIndex == -1) ? this.clientSendtoIndex : clientSendtoIndex
				if(clientSendtoIndex > -1) {
					let clientSendtoId = this.clientsSendto[clientSendtoIndex].id
					this.orders.forEach(e => {
						if(e.client_sendto_id == clientSendtoId) {
							e.order_products.forEach(el => {
								if(el.product_id == productId) {
									sum = sum + parseInt(el.quantity)
								}
							})
						}
					})
				}
				return sum
			},
			percentage(n) {
				return parseInt((n*100) / this.maxQuantity)
			},
			showClientSendtoProductsModal(index){
				this.clientSendtoIndex = index
				this.$refs.clientSendtoProductsModal.click()
			}
		},
		mounted () {
			this.initModuleLocal()
		}
	}
</script>
